module.exports = __webpack_public_path__ + "img/request-tracker-admin.2d7ab821.png";